module.exports = __webpack_public_path__ + "static/lframe-calculator-car-loan-repayment-4c75a83e75d77c5da45c383685a33de3.png";